import { ChangeDetectionStrategy, Component, effect, inject, signal } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from "@angular/router";
import { MatIconModule } from '@angular/material/icon';
import { filter } from 'rxjs';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [RouterModule, MatIconModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LayoutComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  isOnCancelRoute = signal<boolean>(false);

  constructor() {
    // Check initial route
    this.isOnCancelRoute.set(this.router.url.endsWith('/cancel'));

    // Subscribe to route changes
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.isOnCancelRoute.set(event.url.endsWith('/cancel'));
      });
  }

  onClose(): void {
    this.router.navigate(['cancel'], { relativeTo: this.route });
  }
}
